import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-list-user-connecter',
    templateUrl: './list-user-connecter.component.html',
    styleUrls: ['./list-user-connecter.component.css'],
    standalone: false
})
export class ListUserConnecterComponent implements OnInit {

  constructor(private common: CommonService, private modalService: BsModalService) { }
  @ViewChild('msg') msg;
  error = '';
  @Input() listUserConnecter: any[];
  rows = [];
  loadingIndicator = false;
  search = '';
  rowsCopie: any[] = [];
  focus: Boolean = false;
  ngOnInit() {
    this.listUserConnecter = this.listUserConnecter || [];
    this.listUserConnecter = this.listUserConnecter || [];
    this.listUserConnecter.forEach(elt => {
      elt.libelleObjetEntite = `(${elt.login})`;
      elt.dateConnexion = elt.dateConnexion ? moment(elt.dateConnexion, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
      elt.dateUpdate = elt.dateUpdate ? moment(elt.dateUpdate, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
      elt.dateLastModif = elt?.lastLogModification?.date || '';
      elt.heureLastModif = elt?.lastLogModification?.heure || '';
      elt.dateLastModifFr = elt.dateLastModif ? moment(elt.dateLastModif, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
    });
    this.rows = this.listUserConnecter;
    this.rowsCopie = this.listUserConnecter;
  }
  exportXLS() {
    this.common.exportXLSUserConnecter().then((datas) => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.common.openFile(datas.data[0]);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

  searchHandle() {
    const ctrl = this;
    if (this.search !== '') {
      this.rows = [];
      this.rowsCopie.forEach(elt => {
        // console.log(elt);
        if (ctrl.common.eltCorrespond(ctrl.search, elt.libelleObjetEntite)) {
          this.rows.push(elt);
        }
      });
    } else {
      this.rows = this.rowsCopie;
    }
  }

  eltCorrespond(elt) {
    const spliteSearch = this.search.split('%');
    let regex;
    const matchPercent = elt.search(new RegExp('%', 'gi'));
    if (matchPercent) {
      if (this.search.startsWith('%')) {
        if (spliteSearch.length) {
          regex = new RegExp(spliteSearch[1], 'gi');
          return elt.search(regex) >= 0;
        }
      } else {
        const last = this.search.substr(this.search.length - 1);
        const search = (this.search).replace('%', '');
        if (last === '%') {
          const elem = (elt || '').toLocaleLowerCase();
          return elem.startsWith(search.toLocaleLowerCase());
        } else {
          regex = new RegExp(search, 'gi');
          return elt.search(regex) >= 0;
        }
      }
    } else {
      regex = new RegExp(this.search, 'gi');
      return elt.search(regex) >= 0;
    }
  }

}
